/* eslint-disable */
export const setCookie = (name, value, { days, hours } = {}, { sameSite } = {}) => {
	const cookieName = name;
	const cookieValue = encodeURIComponent(value);

	const date = new Date();

	if (days) {
		const daysQuantity = +days;
		date.setDate(date.getDate() + daysQuantity);
	}

	if (hours) {
		const hoursQuantity = +hours;
		date.setHours(date.getHours() + hoursQuantity);
	}

	const expireDate = date.toUTCString();
	const expireDays = `expires=${expireDate}`;
	let secureAttr = '';
	let sameSiteAttr = '';
	const secureProtocol = location && location.protocol === 'https:';

	if (secureProtocol) {
		secureAttr = ';secure';
	}

	if (sameSite) {
		const sameSiteLowerCase = String(sameSite).toLowerCase();

		if (sameSiteLowerCase !== 'none' || (sameSiteLowerCase === 'none' && secureProtocol)) {
			sameSiteAttr = `;SameSite=${sameSite}`;
		}
	}

	document.cookie = `${cookieName}=${cookieValue}; ${expireDays}; path=/${secureAttr}${sameSiteAttr}`;
};

export const getCookie = (name) => {
	const regExp = new RegExp('(?:^|; )' + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + '=([^;]*)');
	const matches = document.cookie.match(regExp);

	return matches ? decodeURIComponent(matches[1]) : null;
};

export const initTimezone = () => {
	setCookie(
		'timezone',
		new Date().getTimezoneOffset(),
		{
			days: 365,
		},
		{
			sameSite: 'None',
		},
	);
};

export const isEnabledCookie = () => {
	let cookieEnabled = navigator.cookieEnabled;

	if (typeof navigator.cookieEnabled === 'undefined' && !cookieEnabled) {
		document.cookie = 'testcookie';
		cookieEnabled = document.cookie.indexOf('testcookie') !== -1;
	}
	return cookieEnabled;
};
